import { type DefaultContext, mutationPromise } from '@egw/clients'
import {
  // type EnrollmentJointManualReviewDataInput,
  type EnrollmentJointManualReviewData,
  type EnrollmentJointManualReviewSubmitInput,
  type EnrollmentJointManualReviewSubmitOutput,
} from '../../../../models'
import { createMutationHook, createQueryHook } from '../../../../hooks'

/**
 * Get Enrollment Joint ManualReview data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentJointManualReviewData>
 * @example const response = await getEnrollmentJointManualReviewData()
 */
export const getEnrollmentJointManualReviewData = async (
  // enrollmentManualReviewSubmitInput?: EnrollmentJointManualReviewDataInput,
  context?: DefaultContext,
): Promise<EnrollmentJointManualReviewData> => {
  const response = (await mutationPromise(
    {
      name: 'getEnrollmentJointManualReviewData',
      query: `mutation getEnrollmentJointManualReviewData($input: SubmitJointEnrollmentInput!) {
        submitJointEnrollment(input: $input) {
          isError
          errors
          activePerson {
            path
            progress
            applicationId
            name {
              firstName
              lastName
            }
            needManualReviewDocumentUpload
          }
        }
      }`,
    },
    {
      input: {},
    },
    context,
  )) as { submitJointEnrollment: EnrollmentJointManualReviewData }
  return response.submitJointEnrollment
}

export const useGetEnrollmentJointManualReviewData = createQueryHook<undefined, EnrollmentJointManualReviewData>(
  getEnrollmentJointManualReviewData,
)

/**
 * Submit Enrollment Joint ManualReview data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentJointManualReviewSubmitOutput>
 * @example const response = await submitEnrollmentJointManualReviewData();
 */
export const submitEnrollmentJointManualReviewData = async (
  enrollmentManualReviewSubmitInput: EnrollmentJointManualReviewSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentJointManualReviewSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentJointManualReviewData',
      query: `mutation submitEnrollmentJointManualReviewData($input: SubmitJointEnrollmentInput!) {
        submitJointEnrollment(input: $input) {
          isError
          errors
          activePerson {
            path
          }
        }
      }`,
    },
    {
      input: enrollmentManualReviewSubmitInput,
    },
    context,
  )) as { submitJointEnrollment: EnrollmentJointManualReviewSubmitOutput }
  return response.submitJointEnrollment
}

export const useSubmitEnrollmentJointManualReviewData = createMutationHook<
  EnrollmentJointManualReviewSubmitInput,
  EnrollmentJointManualReviewSubmitOutput
>(submitEnrollmentJointManualReviewData)
